import React, { useEffect } from "react";
import './style.css'
import StoreListTable from "../../../components/Tables/StoreListTable";

const ManageBranchPage = ({setActivePath}) => {
    useEffect(() => {
        setActivePath("Manage Branch");
      }, [setActivePath]);


  return (
    <div className="outlet-container">
        <StoreListTable showActionButtons={true}/>
      
    </div>
  )
}

export default ManageBranchPage
